export default {
  name: 'pc-footer',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '底部页脚',
          icon: 'el-icon-chat-line-round',
          content: {
            phone: '',
            time: '',
            QRcode: '',
            icp: '',
            images: [],
            ADlist: [{
              label: '正品保障',
              desc: '原厂出品，品质保证',
              img: '/images/bottom_a1.png'
            }, {
              label: '期货保证',
              desc: '"你好"，隐藏美学大师"分享会',
              img: '/images/bottom_a2.png'
            }, {
              label: '专属客服',
              desc: '一对一服务',
              img: '/images/bottom_a3.png'
            }, {
              label: '诚信服务',
              desc: '站在顾客角度服务',
              img: '/images/bottom_a4.png'
            }],
            helpList: []
          },
          config: [{
            label: '底部广告列表',
            name: 'ADlist',
            type: 'mapList',
            value: '最新咨询',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              desc: {
                label: '描述',
                value: 'desc'
              }
            }
          }, {
            label: '客服电话',
            name: 'phone',
            type: 'input',
            value: ''
          }, {
            label: '工作时间',
            name: 'time',
            type: 'input',
            value: ''
          }, {
            label: '二维码',
            name: 'QRcode',
            type: 'image',
            value: '',
            attrs: {
              limit: 1,
              serialize: true
            }
          }, {
            label: '关注我们',
            name: 'images',
            type: 'image',
            value: [],
            attrs: {
              limit: 3
            }
          }, {
            label: '帮助中心',
            name: 'helpList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              children: true
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};